import * as styled from '../../../../util/styled'
import { useBrandId, useCampaignId } from '../../../../hooks/useGlobalRouting'
import { useCampaignList } from './useCampaignList'
import { Campaign } from './Campaign'

const Section = styled.section<{ top?: boolean }>((props) => ['pb-2', !props.top && 'pt-2'])
const SectionLabel = styled.section<{}, { 'aria-label': string }>('font-semibold text-text-tertiary text-xs mx-4')
export const CampaignList = () => {
  const [brandId] = useBrandId()
  const { data } = useCampaignList(brandId)
  const campaignId = useCampaignId()
  
  return (
    <Section>
      <SectionLabel aria-label='List of user campaigns'>Campaigns</SectionLabel>
      {brandId && data?.campaigns.items.map(item => (
        <Campaign
          key={item.id}
          brandId={brandId}
          campaign={item}
          active={campaignId === item.id}
          activeBrandId={brandId}
        />
      ))}
    </Section>  
  )
}